import HooksModalV5Key from "app/constants/HooksModalV5Key";
import FeatureUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/FeatureUpgradeBanner/FeatureUpgradeBanner";
import trackingService from "app/pages/sales-intelligence/common-components/feature-upgrade/services/tracking/trackingService";
import { featureHookKeys } from "app/pages/sales-intelligence/utils/i18n/feature-hook";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import appsSearchI18nKeys from "../../../utils/i18n";

type Props = {
    isSubmitSuccess: boolean;
    onSubmit: VoidFunction;
};

const AppsFeatureUpgradeBanner = ({ isSubmitSuccess, onSubmit }: Props) => {
    const handleOnSubmit = () => {
        trackingService.trackFeatureAccessRequested(HooksModalV5Key.AppLeadGenerator);
        void requestFeature(HooksModalV5Key.AppLeadGenerator);

        onSubmit();
    };

    return (
        <FeatureUpgradeBanner
            headerKey={appsSearchI18nKeys.upgradeBannerHeader}
            titleKey={appsSearchI18nKeys.upgradeBannerTitle}
            subtitleKey={appsSearchI18nKeys.upgradeBannerSubtitle}
            buttonTextKey={featureHookKeys.speakWithUsCta}
            onSubmit={handleOnSubmit}
            isSubmitted={isSubmitSuccess}
        />
    );
};

export default AppsFeatureUpgradeBanner;
